import type { PermissionForm, QuotaLimits } from './types'

const GiB = 1024 ** 3
const toGiB = (bytes: number | null | undefined) =>
  typeof bytes === 'number' && bytes > 0 ? Math.floor(bytes / GiB) : 0

const DEFAULT_LIMITS: QuotaLimits = {
  instanceQty: 200,
  snapQty: 200,
  meshNet: 10,
  storageBytes: 2199023255552,
}

export function getPermissionOverMax(form: PermissionForm, limits?: QuotaLimits) {
  const effectiveLimits = limits ?? DEFAULT_LIMITS
  const overInstance = (form.instanceQtyQuota ?? 0) > effectiveLimits.instanceQty
  const overSnap = (form.snapQtyQuota ?? 0) > effectiveLimits.snapQty
  const overMeshNet = (form.meshNetQuota ?? 0) > effectiveLimits.meshNet
  const storageGiB = toGiB(form.storageCapBytesQuota)
  const overStorage = (form.storageCapBytesQuota ?? 0) > effectiveLimits.storageBytes

  const overAny = overInstance || overSnap || overMeshNet || overStorage

  return {
    overAny,
    details: {
      overInstance,
      overSnap,
      overMeshNet,
      overStorage,
      storageGiB,
    },
    limits: {
      instanceQty: effectiveLimits.instanceQty,
      snapQty: effectiveLimits.snapQty,
      meshNet: effectiveLimits.meshNet,
      storageGiB: toGiB(effectiveLimits.storageBytes),
    },
  }
}
